import { css } from "@emotion/react"
import { MouseEvent} from "react"
import { ArticleWithPhoto, PhotoWithIndex } from "type"
import { SelectVideoItem, SelectImageItem } from "./component"
import { Button } from "component"

type Props = {
  article: ArticleWithPhoto
  selectedList: Array<string>
  onPhotoClick? : (evt: MouseEvent<HTMLImageElement>, index: number)=>void
  onVideClick?: (evt: MouseEvent<HTMLDivElement>, index: number)=>void
  onButtonClick?: (evt: MouseEvent<HTMLButtonElement>)=>void
}

export const ChangeOrder = (props: Props) =>{

  const photoElements = props.article.photos.map((v, idx)=>{
    const photoWithIndex : PhotoWithIndex = {
      ...v,
      index: idx
    }

    const element = v.type === 'video' ?(
      < SelectVideoItem
        photo={photoWithIndex}
        onClick={props.onVideClick} 
        order={props.selectedList.findIndex(v=>v === photoWithIndex.filename)+1}
        isSelected={props.selectedList.includes(photoWithIndex.filename)} 
      />
    ):(
      <SelectImageItem
        photo={photoWithIndex}
        onClick={props.onPhotoClick}
        order={props.selectedList.findIndex(v=>v === photoWithIndex.filename)+1}
        isSelected={props.selectedList.includes(photoWithIndex.filename)} 
      />
    )

    return(
      <li css={liCss} key={v.filename}>
        {element}
      </li>
    )
  })

  return(
    <div css={changeOrderContainerCss}>
      <ul css={photoListContainerCss}>
        {photoElements}
      </ul>
      <div css={buttonContainerCss}>
        <Button onClick={props.onButtonClick}>
          Update
        </Button>
      </div>
    </div>
  )
}

const changeOrderContainerCss=  css`
`

const photoListContainerCss=css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-gap: 3px;
  margin: 0;
  padding: 0;
`

const liCss = css`
  aspect-ratio: 1;
  position: relative;
  list-style-type: none;
  margin: 0;
  padding: 0;
`

const buttonContainerCss=css`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
`